// extracted by mini-css-extract-plugin
module.exports = {"header":"IndicatorDetailsHeader_header_2apHM","lines":"IndicatorDetailsHeader_lines_jbsoQ"};